import { opaccAjaxPlugin, opaccLogPlugin } from '../opacc.static.js';
import { basketMessages } from '../messages/opacc.messages.js';

/** @module basket */

/**
 * Basisklasse für die Warenkorb-Funktionalität
 *
 */
export class OpaccBasket {
	constructor(selector = '.opc-basket-info') {
		this.basketInfoButtonSelector = 'button';
		this.wrapperElement = document.querySelector('body');
		this.basketInfo = document.querySelector(selector);
		this.basketList = this.wrapperElement.querySelector('.basket-list');
		this.basketOverview = this.wrapperElement.querySelector('.page-basket');

		if (this.basketInfo) {
			this.miniBasket = this.basketInfo.querySelector('.mini-basket');
			this.basketAsyncTemplate = this.basketInfo.dataset.opAsynctemplate || '';
		}

		if (this.miniBasket) {
			this.miniBasketList = this.miniBasket.querySelector('[data-op-asyncbasket="basket-items"]');
			this.miniBasketItems = this.miniBasket.querySelectorAll('.basket-item');
			this.redirectMiniBasket = undefined;
			this.redirectMiniBasketLink = this.miniBasket.querySelector('.opc-button[data-op-type="checkout"]').href;
			this.offCanvasNaviElement = document.querySelector('.offcanvas-menu-trigger');
		}
	}

	/**
	 *
	 *
	 */
	attachEventListener() {}

	/**
	 *
	 *
	 * @param {*} item
	 */
	sendAjaxRequest(item) {
        let url = opaccAjaxPlugin.setAsyncUrl();

        if (this.constructor.name === 'OpaccBasketInfo') {
            url = opaccAjaxPlugin.setAsyncUrl(false);
        }

		this.hookBeforeSendAjaxRequest(item);
		opaccAjaxPlugin.fetchAsynPostForm(url, this.prepareDataSubmission(item), this.refreshResultList.bind(this, item), this.asyncErrorHandler.bind(this), true);
	}

	/**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */
	prepareDataSubmission(item) {
		let data = {
			type: 'basket',
			action: item.dataset.opBtnaction,
			module: item.dataset.opModule,
			originalUrl: window.location.href
		};

		if (data.action == 'change') {
			var selectElement = item.previousElementSibling;
			while (selectElement && selectElement.tagName !== 'SELECT') {
				selectElement = selectElement.previousElementSibling;
			}
			if (selectElement) {
				data.artdimvariantno = selectElement.value;
			}
		}
		if (item.dataset.opArtinternalno) {data.artInternalNo = item.dataset.opArtinternalno;}
		if (item.dataset.opSaldocitemboid) {data.salDocItemBoId = item.dataset.opSaldocitemboid;}
		if (item.dataset.opSaldocboid) {data.salDocBoId = item.dataset.opSaldocboid;}
		if (item.dataset.opOption) {data.addalloptions = item.dataset.opOption;}
		if (item.dataset.opVariant) {data.artDimVariantNo = item.dataset.opVariant;}
		if (item.dataset.opQuantityid1) {data.catItemQuantityDim1 = this.getButtonDimValue(item, item.dataset.opQuantityid1);}
		if (item.dataset.opQuantityid2) {data.catItemQuantityDim2 = this.getButtonDimValue(item, item.dataset.opQuantityid2);}
		if (item.dataset.opQuantityid3) {data.catItemQuantityDim3 = this.getButtonDimValue(item, item.dataset.opQuantityid3);}
		if (item.dataset.opAsynctemplate) {data.template = item.dataset.opAsynctemplate;}
		if (item.dataset.opRequest) {data.request = item.dataset.opRequest;}
		if (item.dataset.opEncrypted) {data.encrypted = item.dataset.opEncrypted;}

		Array.from(item.attributes).forEach(property => {
			if (property.name.indexOf('data-op-saldocitem.') === 0) {
				data[property.name.substring(8)] = property.value;
			}
		});

		if (item.dataset.opBtnaction === 'addall') {
			data.addall = this.getNewQuantityFromPosition();
			if (data.addall === '{}') {
				delete data.addall;
			}
		}

		return this.hookBeforeReturnPrepareDataSubmission(item, data);
	}

	/**
	 * Angepasste Menge der Quelldokument-Positionen ermitteln
	 *
	 * @returns {*}
	 */
	getNewQuantityFromPosition() {
		let dimIndex = {};
		let listItems = this.wrapperElement.querySelectorAll('.opc-item-list .list-item, .opc-article-list li');
		Array.from(listItems).forEach( item => {
			let internalNo = null;
			if (item.dataset.opInternalno) {internalNo = item.dataset.opInternalno;}
			if (internalNo) {
				// find Basekt-button from current Item
				let itemBasket = item.querySelector('.opc-basket-button');
				if (itemBasket) {
					let itemBasketDim = itemBasket.querySelectorAll('.basket-button-dim-1:not(.is-inactive), .basket-button-dim-2:not(.is-inactive), .basket-button-dim-3:not(.is-inactive)');
					Array.from(itemBasketDim).forEach( (dim, index) => {
						dimIndex[`position${internalNo}dim${index+1}`] = dim.querySelector('.basket-button-quantity').value;
					});
				}
			}
		});
		return JSON.stringify(dimIndex);
	}

	/**
	 *
	 *
	 * @param {*} data
	 */
	updateMiniBasket(data) {
		if (this.miniBasket && !this.basketOverview) {
			this.miniBasket.querySelector('.mini-basket-quantity').innerHTML = data.quantity;
			this.miniBasketList.innerHTML = data.items;
			let amount = this.miniBasket.querySelector('.mini-basket-footer-total');
			if (amount) {
				let amountText = amount.firstElementChild;
				amount.innerHTML = `${amountText.outerHTML} ${data.currency} ${data.amount}`;
			}
		}
		if (this.basketInfo) {
			this.basketInfo.querySelector('.basket-info-count').innerHTML = data.quantity > 0 ? data.quantity : '';
		}

		this.hookAfterUpdateMiniBasket(data);
	}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */
	updateBasket(item, data) {
		if (this.basketList) {
			if (item.dataset.opBtnaction == 'delete' || item.dataset.opBtnaction == 'deleteall') {
				if (+data.quantity === 0) {
					// if quickorder activated, refresh page
					if(this.basketList.dataset.opQuickorder === "true") {
						location.reload();
					} else {
						let emptyInfo = document.createElement('div');
						emptyInfo.classList.add('opc-message');
						emptyInfo.dataset.opType = 'info';
						emptyInfo.innerHTML = basketMessages.messageEmptyBasket.text;
						this.basketList.parentNode.replaceChild(emptyInfo, this.basketList);
					}
				} else {
					let basketPos = this.basketList.querySelector(`[data-op-internalno="${item.dataset.opInternalno}"]`) || item.closest('.basket-list-item');
					if (basketPos) {
						basketPos.remove();
					}
				}
			} else if (item.dataset.opBtnaction == 'change') {
				// update item price and amount
				let price = item.closest('.basket-list-item').querySelector('[data-op-asyncbasket="itemPrice"]');
				if (price) {
					price.innerHTML = `${data.currency} ${data.itemPrice}`;
				}
				let amount = item.closest('.basket-list-item').querySelector('[data-op-asyncbasket="itemAmount"]');
				if (amount) {
					amount.innerHTML = `${data.currency} ${data.itemAmount}`;
				}
			} else if (item.closest('.opc-quickorder')) {
				// update after quickorder
				let quickorder = item.closest('.opc-quickorder');
				if(quickorder.dataset.opRefresh === 'false') {
					opaccAjaxPlugin.fetchAsynGetForm(quickorder.dataset.opUrlRefresh, this.refreshBasketList.bind(this), this.asyncErrorHandler.bind(this), true);
				}
			}

			// update total amount and VAT
			let totalAmount = this.basketList.querySelector('[data-op-asyncbasket="totalAmount"]');
			if (totalAmount) {
				totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
			}
			let totalVat = this.basketList.querySelector('[data-op-asyncbasket="totalVat"]');
			if (totalVat) {
				totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
			}
		} else if (item.closest('.opc-quickorder')) {
			// refresh after quickorder
			let quickorder = item.closest('.opc-quickorder');
			if(quickorder.dataset.opRefresh === 'true') {
				window.location.href = quickorder.dataset.opUrlRefresh;
			}
		}

		this.hookAfterUpdateBasket(item,data);
	}

	/**
	 *
	 * @param {*} response
	 */
	refreshBasketList(response) {
		if(response && response.success) {
			const basketListBodyWrapper = this.basketList.querySelector('.basket-list-body-wrapper');
			if(basketListBodyWrapper) {
				basketListBodyWrapper.innerHTML = response.dataAsHtml;
			}
		}
	}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} response
	 */
	refreshResultList(item, response) {
		response = this.hookBeforeRefreshResultList(item, response);
		item.classList.remove('is-progress');

		let basketButtons = this.wrapperElement.querySelectorAll(`${this.basketButtonContainer}[data-op-modal],${this.basketButtonContainer} button[data-op-btnaction], ${this.basketButtonContainer} button[data-op-qtychange]`);

		this.toggleButtonState(Array.from(basketButtons).filter(basketItem => basketItem != item), 'all');
		this.toggleQuantityChangerState(this.getQuantityChangerElements(item), 'all');
		if (response.success) {
			this.showSuccessIndicator(item);
			this.updateMiniBasket(response.dataAsJson);
			this.updateBasket(item, response.dataAsJson);
			if (response.dataAsJson.action === 'added') {
				opaccLogPlugin.hideModal();
				opaccLogPlugin.showMessage(this.getQuantityMessage(item));
			}
		}

		this.hookAfterRefreshResultList(item, response);
	}

	/**
	 *
	 *
	 * @param {*} [targetId=null]
	 * @param {*} response
	 */
	refreshContent(targetId = null, response) {
		if (response.success) {
			let url = targetId ? targetId : window.location.href;

			opaccAjaxPlugin.fetchAsynPostForm(url, {}, this.refreshPageContent.bind(this), this.asyncErrorHandler.bind(this), true);
		}
	}

	/**
	 *
	 *
	 * @param {*} response
	 */
	refreshPageContent(response) {
		if (response.success) {
			let htmlObj = document.createElement('div');
			htmlObj.innerHTML = response.dataAsHtml;
			document.querySelector('#checkout-content').innerHTML = htmlObj.querySelector('#checkout-content').innerHTML;
		}
	}

	/**
	 *
	 *
	 * @param {*} button
	 * @param {*} dimNumIdVal
	 * @returns {*}
	 */
	getButtonDimValue(button, dimNumIdVal) {
		let retVal = '';
		let parent = button.parentElement;
		let dim = parent.querySelector(`[data-op-dim="${dimNumIdVal}"]`);
		let inactive = dim.classList.contains('is-inactive');
		let input = dim.querySelector('input.basket-button-quantity');
		let value = input.value;

		let defaultValue = input.min || 1;

		if (!inactive) {
			if (isNaN(value) || value <= 0) {
				input.value = defaultValue;
				retVal = defaultValue;
			} else {
				retVal = value;
			}
		}
		return retVal;
	}

	/**
	 *
	 *
	 * @param {*} button
	 * @param {*} dimNumIdVal
	 * @returns {*}
	 */
	getButtonDimUnit(button, dimNumIdVal) {
		let unit = '';
		let parent = button.parentElement;
		let dim = parent.querySelector(`[data-op-dim="${dimNumIdVal}"]`);
		let inactive = dim.classList.contains('is-inactive');
		if (!inactive) {
			let unitElement = dim.querySelector('.basket-button-dim-unit');
			if (unitElement) {
				unit = unitElement.innerText;
			}
		}
		return unit;
	}

	/**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */
	getQuantityMessage(item) {
		let message = Object.assign({}, basketMessages.messageAddedToBasket);
		let dim1Value = this.getButtonDimValue(item, item.dataset.opQuantityid1);
		let dim1Unit = this.getButtonDimUnit(item, item.dataset.opQuantityid1);
		let dim2Value = this.getButtonDimValue(item, item.dataset.opQuantityid2);
		let dim2Unit = this.getButtonDimUnit(item, item.dataset.opQuantityid2);
		let dim3Value = this.getButtonDimValue(item, item.dataset.opQuantityid3);
		let dim3Unit = this.getButtonDimUnit(item, item.dataset.opQuantityid3);
		let quantity = `${dim1Value} ${dim1Unit} `;
		if (dim2Value) {
			quantity = `${quantity}x ${dim2Value} ${dim2Unit} `;
		}
		if (dim3Value) {
			quantity = `${quantity}x ${dim3Value} ${dim3Unit} `;
		}
		message.text = quantity + basketMessages.messageAddedToBasket.text;

		return message;
	}

	/**
	 *
	 *
	 * @param {*} e
	 * @returns {*}
	 */
	eventPath(e) {
		let path = (e.composedPath && e.composedPath()) || e.path,
			target = e.target;

		if (path != null) {
			// Safari doesn't include Window, but it should.
			return (path.indexOf(window) < 0) ? path.concat(window) : path;
		}

		if (target === window) {
			return [window];
		}

		function getParents(node, memo) {
			memo = memo || [];
			var parentNode = node.parentNode;

			if (!parentNode) {
				return memo;
			}
			else {
				return getParents(parentNode, memo.concat(parentNode));
			}
		}

		return [target].concat(getParents(target), window);
	}

	/**
	 *
	 *
	 * @param {*} target
	 * @returns {*}
	 */
	getQuantityChangerElements(target) {
		let buttonArray = [];
		if (this.basketList) {
			buttonArray = Array.from(this.basketList.querySelectorAll('.opc-button[data-op-qtychange="dec"], .opc-button[data-op-qtychange="inc"]'));
		} else {
			let decrementButton = target.parentElement.querySelector('.opc-button[data-op-qtychange="dec"]');
			let incrementButton = target.parentElement.querySelector('.opc-button[data-op-qtychange="inc"]');

			if (decrementButton === null || incrementButton === null) {
				return [];
			}
			buttonArray = [decrementButton, incrementButton];
		}
		return buttonArray;
	}

	/**
	 *
	 *
	 * @param {*} buttons
	 * @param {*} value
	 */
	toggleQuantityChangerState(buttons, value) {
		this.toggleButtonState(buttons, value);
	}

	/**
	 *
	 *
	 * @param {*} buttons
	 * @param {*} value
	 */
	 toggleButtonState(buttons, value) {
		Array.from(buttons).forEach(item => {
			item.style.pointerEvents = value;
			if (value === 'none' && !item.classList.contains('opc-basket-info')) {
				item.parentElement.style.cursor = 'not-allowed';
			} else {
				item.parentElement.style.cursor = 'default';
			}
		});
	}

	/**
	 *
	 *
	 * @param {*} error
	 */
	asyncErrorHandler(error) {
		// eslint-disable-next-line no-console
		console.error('Request failed: ', error.message);
		this.hookAfterAsyncErrorHandler(error);
	}


	// ---------------------------------

	/**
	 *
	 *
	 * @param {*} item
	 */
	// eslint-disable-next-line no-unused-vars
	hookBeforeSendAjaxRequest(item){}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeReturnPrepareDataSubmission(item, data){ return data;}

	/**
	 *
	 *
	 * @param {*} data
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterUpdateMiniBasket(data){}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterUpdateBasket(item,data){}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeRefreshResultList(item, data) {return data;}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterRefreshResultList(item, data){}

	/**
	 *
	 *
	 * @param {*} error
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterAsyncErrorHandler(error){}

}